import React, { useContext } from 'react';
import ThemePanel from '../panels/ThemePanel';
import TextFieldsPanel from '../panels/TextFieldsPanel';
import SliderStylingPanel from '../panels/SliderStylingPanel';
import ButtonStylingPanel from '../panels/ButtonStylingPanel';
import TextFieldStylingPanel from '../panels/TextFieldStylingPanel';
import LeadingQuestionPanel from '../panels/LeadingQuestionPanel';
import CountdownPanel from '../panels/CountdownPanel';
import { ListWrapper } from '../Steps/components';
import UrlTargetPanel from '../panels/UrlTargetPanel';
import PhoneNumberPanel from '../panels/PhoneNumberPanel';
import SocialProfilePanel from '../panels/SocialProfilePanel';
import ImagePanel from '../panels/ImagePanel';
import HeadlinePanel from '../panels/HeadlinePanel';
import CTAPanel from '../panels/CTAPanel';
import NoThanksPanel from '../panels/NoThanksPanel';
import Subheadline1Panel from '../panels/Subheadline1Panel';
import FormBuilderPanel from '../panels/FormBuilderPanel';
import FormStylingPanel from '../panels/FormStylingPanel';
import { EditorContext } from '../../../utils/contexts';

export default function SliderDesign() {
  const { settings } = useContext(EditorContext);
  const isForms =
    settings.element_subtype === 'forms' ||
    settings.subtype === 'forms' ||
    !!settings.form_type ||
    (Array.isArray(settings.form_questions) && settings.form_questions.length > 0);

  if (isForms) {
    return (
      <ListWrapper>
        <ThemePanel />
        <SliderStylingPanel />
        <Subheadline1Panel />
        <FormStylingPanel />
        <FormBuilderPanel />
        <ImagePanel />
        <ButtonStylingPanel />
      </ListWrapper>
    );
  }

  return (
    <ListWrapper>
      <ThemePanel />
      <SliderStylingPanel />
      <HeadlinePanel />
      <Subheadline1Panel />
      <TextFieldsPanel />
      <TextFieldStylingPanel />
      <PhoneNumberPanel />
      <SocialProfilePanel />
      <ImagePanel />
      <UrlTargetPanel />
      <CTAPanel />
      <ButtonStylingPanel />
      <NoThanksPanel />
      <LeadingQuestionPanel />
      <CountdownPanel />
    </ListWrapper>
  );
}
